export default "/images/vendor/flag-icons/flags/4x3/st.svg?96f88011c65a964bfb0f5e17f678123f";